import { always, apiFetch } from 'utils'

function queryForGet (page, route, { search, categories, subCategories }) {
  return {
    page,
    search
  }
}

export function get (page, route, resourceFilters) {
  return apiFetch('/resource', queryForGet(page, route, resourceFilters))
  .catch(always([]))
}

export function getSingle (id) {
  return apiFetch(`/resource/${id}`)
}



// WEBPACK FOOTER //
// ./resources/assets/js/transport/resource.js